import {Component, OnInit, inject} from '@angular/core';
import {PercentPipe} from '@angular/common';
import {MatChipsModule} from '@angular/material/chips';
import {ChangeIndicator, Direction} from '../../../models/change-indicator';
import {GoalCompletionRateSeriesService} from '../goal-completion-rate-chart/goal-completion-rate-series.service';

@Component({
  selector: 'app-goal-completion-rate-kpi',
  templateUrl: './goal-completion-rate-kpi.component.html',
  styleUrls: ['./goal-completion-rate-kpi.component.scss'],
  standalone: true,
  imports: [MatChipsModule, PercentPipe],
})
export class GoalCompletionRateKpiComponent implements OnInit {
  private goalCompletionRateSeriesService = inject(
    GoalCompletionRateSeriesService
  );

  improved: boolean = false;
  steady: boolean = false;
  worsened: boolean = false;

  changeIndicator: ChangeIndicator;

  ngOnInit() {
    this.goalCompletionRateSeriesService.mostRecentChangeIndicator$.subscribe(
      (changeIndicator) => {
        this.changeIndicator = changeIndicator;
        this.initDefaultChangeIndicators();
        switch (changeIndicator.direction) {
          case Direction.up:
            this.improved = true;
            break;
          case Direction.steady:
            this.steady = true;
            break;
          case Direction.down:
            this.worsened = true;
            break;
          case Direction.none:
            break;
          default:
            throw new Error(
              `no state is set for kpi change indicator ${changeIndicator.direction}`
            );
        }
      }
    );
  }

  private initDefaultChangeIndicators(): void {
    this.worsened = false;
    this.steady = false;
    this.improved = false;
  }
}
